import ActionType from '../redux/actionType';
export const makeFetchSuccessActionType = (actionType: string) => {
  return actionType + '_' + ActionType.FETCH_SUCCESS;
};

export const makeFetchFailedActionType = (actionType: string) => {
  return actionType + '_' + ActionType.FETCH_FAILED;
};
